<template>
	<div>
		<div class="cgqBox">
			<div class="cgqBoxTil">
				{{list.data.menuTitle}}
			</div>
			<div class="cgqBoxSp" :style="{
				paddingLeft:bj+'px'
			}">
				<img :src="list.data.imgs" />
				<!-- <video></video> -->
			</div>
			<div class="data44Box">
				<div class="swiper-hexinTwo80" :class="`swiper-hexinTwo80${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slideTwo" v-for="(itema,indexa) in list.data.content"
							:key="indexa">
							<div class="swiper-slideTwo-img">
								<img :src="itema.cover" />
							</div>
							<div class="swiper-slideTwo-imgTwo">
								<img :src="itema.icon" />
							</div>
							<div class="swiper-slideTwo-name">
								{{itema.title}}
							</div>
							<div class="swiper-slideTwo-cen">
								<div v-for="(item,index) in itema.desc" :key="index">{{item.text}}</div>
							</div>
						</div>
					</div>
					
					<template v-if="headerShow">
						<div class="swiper-hexin-prev" v-if="list.data.content.length>2" :style="{
							display:prev,
							left:(bj+30)+'px'
						}">
								<img src="@/assets/product/page6/zjt.png" />
							</div>
							<div class="swiper-hexin-next" v-if="list.data.content.length>2" :style="{
							display:next,
							right:(bj+30)+'px'
						}">
								<img src="@/assets/product/page6/yjt.png" />
							</div>
							</template>
					<template v-else>
						<div class="swiper-hexin-prev" v-if="list.data.content.length>1" :style="{
							display:prev,
							left:'30px'
						}">
								<img src="@/assets/product/page6/zjt.png" />
							</div>
							<div class="swiper-hexin-next" v-if="list.data.content.length>1" :style="{
							display:next,
							right:'30px'
						}">
								<img src="@/assets/product/page6/yjt.png" />
							</div>
							</template>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				// list: [{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/tbcd.png"),
				// 		name: '同步传导',
				// 		cen: '结肠镜插入部的惯性设计将手柄处操作者的推拉力和旋转力传递到结肠镜的先端部，能够帮助医生更好地进镜到盲肠'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/rykt.png"),
				// 		name: '软硬可调',
				// 		cen: '结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度，可满足结肠不同部位的进镜需求'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/rykt.png"),
				// 		name: '随动弯曲',
				// 		cen: '可顺应结肠不同部位的转向，在脾曲肝曲等部位'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/zmxt.png"),
				// 		name: '头端3光窗照明系统',
				// 		cen: '- 提供角度更大、更均匀的照明效果- 与大视场角结合可得到更好的图像效果'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		imgTwo: require("@/assets/product/page11/fss.png"),
				// 		name: '副送水',
				// 		cen: '- AQ-300系列全线内镜均配备前向副送水功能- 帮助在诊断和治疗过程中实时保持视野清晰，快速发现出血点'
				// 	},
				// ],
				mySwiper: "",
				sliact: 0,
				prev: 'none',
				next: 'block',
				bj: ''
			}
		},
		watch: {
			bj() {
				let t = this;
				// freeMode: true,
				let name = '.swiper-hexinTwo80' + this.list.index;
				this.mySwiper = new this.$swiper(name, {
					// 内部Swiper的选项
					direction: 'horizontal',
					widch: 580,
					slidesPerView: 'auto', // 每屏显示3个滑块
					spaceBetween: 40,
					slidesOffsetBefore: this.bj,
					slidesOffsetAfter: this.bj,
					autoplay: false,
					// 自动播放
					// autoplay: {
					// 	delay: 3000,
					// 	disableOnInteraction: false,
					// },
					allowTouchMove: this.list.data.content.length > 1 ? true : false,
					navigation: {
						prevEl: ".swiper-hexin-prev",
						nextEl: ".swiper-hexin-next",
					},
					on: {
						slideChangeTransitionEnd: function() {
							if (this.activeIndex === 0) {
								t.prev = 'none';
							} else {
								t.prev = 'block';
							}
							if (this.activeIndex === this.slides.length - 1) {
								t.next = 'none';
							} else {
								t.next = 'block';
							}
							if(this.headerShow){
								if (this.activeIndex === this.slides.length - 2) {
									t.next = 'none';
								} else {
									t.next = 'block';
								}
							}
							
						},
					},
				});
			}
		},
		mounted() {
			let t = this;
			this.getWidth();

		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.cgqBox {

		padding-bottom: 150px;

		.cgqBoxTil {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			width: 1200px;
			margin: 0 auto;
			margin-bottom: 61px;
		}

		.cgqBoxCen {
			width: 1200px;
			margin: 0 auto;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
			margin-bottom: 63px;
		}

		.cgqBoxSp {
			width: 100%;
			height: 600px;
			padding-left: 160px;
			margin-bottom: 38px;
			box-sizing: border-box;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			video {
				width: 100%;
				height: 100%;
			}
		}

		.cgqBoxXiao {
			display: flex;
			overflow-x: auto;

			.cgqBoxFor:not(:last-child) {
				margin-right: 40px;
			}

			.cgqBoxFor {
				width: 300px;

				.cgqBoxForImg {
					width: 70px;
					height: 70px;
					margin-bottom: 40px;

					img {
						width: 70px;
						height: 70px;
						object-fit: cover;
					}
				}

				.cgqBoxForName {
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #000000;
					margin-bottom: 32px;
				}

				.cgqBoxForCen {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}

	.swiper-hexinTwo80 {
		overflow: hidden;
		position: relative;
		width: 100%;

		.swiper-hexin-prev {
			position: absolute;
			top: 220px;
			left: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;

			img {
				width: 51px;
				height: 51px;
			}

			cursor: pointer;
			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;

		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 220px;
			right: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			border-radius: 100%;
			transition: all 0.3s ease;
			cursor: pointer;

			img {
				width: 51px;
				height: 51px;
			}
		}
	}

	.swiper-slideTwo {
		position: relative;

		width: 580px;

		.swiper-slideTwo-img {
			width: 580px;
			height: 440px;
			margin-bottom: 36px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.swiper-slideTwo-imgTwo {
			width: 70px;
			height: 70px;
			margin-bottom: 30px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.swiper-slideTwo-name {
			font-size: 26px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			margin-bottom: 20px;
		}

		.swiper-slideTwo-cen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;

			>div {
				white-space: pre-line;
			}
		}
	}

	@media screen and (max-width:1200px) {
		.cgqBox {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;

			.cgqBoxTil {
				font-size: 24px !important;
				margin-bottom: 20px !important;
				width: 100% !important;
			}

			.cgqBoxCen {
				font-size: 14px !important;
				margin-bottom: 20px !important;
				width: 100% !important;
			}

			.swiper-slide {
				width: 100% !important;
			}

			.cgqBoxSp {
				height: auto !important;
				margin-bottom: 20px !important;

				img {
					height: auto !important;
				}

				video {
					height: auto !important;
				}
			}

			.cgqBoxXiao {
				flex-wrap: wrap;

				.cgqBoxFor:not(:last-child) {
					margin-right: 0px !important;
				}

				.cgqBoxFor:nth-of-type(2n-1) {
					margin-right: 20px !important;
				}

				.cgqBoxFor {
					min-width: calc(50% - 10px) !important;

					.cgqBoxForImg {
						width: 40px;
						height: 40px;
						margin-bottom: 20px !important;

						img {
							width: 40px !important;
							height: 40px !important;
							object-fit: cover;
						}
					}

					.cgqBoxForName {
						font-size: 18px !important;
						margin-bottom: 20px !important;
					}

					.cgqBoxForCen {
						font-size: 14px !important;
					}
				}
			}

			// .swiper-hexin-next {
			// 	display: none !important;
			// }

			// .swiper-hexin-prev {
			// 	display: none !important;
			// }
		}
		
		.swiper-slideTwo {
			width: 100% !important;
			.swiper-slideTwo-img {
				width: 100% !important;
				height: auto !important;
				margin-bottom: 20px !important;
		
				img {
					width: 100%;
					height: auto !important;
					object-fit: contain !important;
				}
			}
		
			.swiper-slideTwo-imgTwo {
				width: 35px !important;
				height: 35px !important;
				margin-bottom: 20px !important;
		
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		
			.swiper-slideTwo-name {
				font-size: 18px !important;
			}
		
			.swiper-slideTwo-cen {
				font-size: 14px !important;
			}
		}
	}
</style>